import React from "react";
import PropTypes from "prop-types";
import useWindowSize from "../../_Common/useWindowSize";
import { MOBILE_BREAKPOINT } from "../../_Common/constants";

const Space = ({ mobile, desktop }) => {
  const size = useWindowSize();

  const height =
    size.width >= MOBILE_BREAKPOINT ? `${desktop}px` : `${mobile}px`;

  return <div style={{ height }} />;
};

Space.propTypes = {
  mobile: PropTypes.number.isRequired,
  desktop: PropTypes.number.isRequired
};

export default Space;
